import { modalsActionCreator } from '../events/modals';

const { remove } = modalsActionCreator;

const toggleOffModal = () => dispatch => dispatch(remove());

export default toggleOffModal;
